import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
  Box,
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { useNavigate } from 'react-router-dom'

import { Formik } from 'formik'
import { addDays } from 'date-fns'
import { faDollarSign } from '@fortawesome/free-solid-svg-icons'
import { titleTypes } from '../../components/Selector/Selector'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import { useLabels } from '../../utils/hooks/useLabels/useLabels'
import RechargeForm from '../RechargeForm'
import IconButton from '../../components/IconButton/IconButton'
import { formContexts } from '../RechargeForm/FormFactory/FormFactory'
import SelectorField from '../../components/Selector/SelectorField'
import { DatePickerField } from '../../components/DatePicker/DatePIckerField/DatePickerField'
import { REPOSITORY } from '../../api/repository/Repository'
import { defaultOptions } from '../RechargeForm/FormFactory/Forms/Discount/IndividualDiscount'
import { RefillContext } from '../../utils/hooks/Context/RefillContext'
import { useRequestStatusContext } from '../../utils/hooks/Context/RequestStatusContext'
import { calculateAmount, formatDniData, rechargeTypes } from './utils'
import { useLoadingContext } from '../../utils/hooks/Context/LoadingContext'
import { colors } from '../../utils/theme/styles'
import { numberFormat } from '../../utils/formats/formats'
import ConfirmModal from '../../components/CustomConfirmations/ConfirmModal'
import RefillsConfirmation from '../../components/CustomConfirmations/RefillsConfirmation'
import Toast from '../../components/Toast/Toast'
import RefillsIndicator from '../../components/Toast/ToastContents/RefillsIndicator/RefillsIndicator'

function NewRefill() {
  const [validDuplicates, setValidDuplicates] = useState({
    valid: true,
    showModal: false,
  })

  const currentUser = JSON.parse(localStorage.getItem('currentUser'))

  const { texts } = useLabels()
  const navigate = useNavigate()
  const [notitfy, setNotify] = useState(true)
  const [costCenterAssign, setCostCenterAssign] = useState(null)
  const [cEmpleados, setCEmpleados] = useState([])

  const [cEmpleadosLocalFilter, setCEmpleadosLocalFilter] = useState([])

  const { sSucursal, sCentroCosto, sEmpresa } =
    REPOSITORY.local.company.getCompanyData()
  const branchOffices = [{ id: '', label: 'Todos', value: '' }, ...sSucursal]
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()
  const [form, setForm] = useState(null)
  const [confirmed, setConfirmed] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [data, setData] = useState({})
  const [availableBalance, setAvailableBalance] = useState('')
  const onSelectCostCenter = (value) => {
    setCostCenterAssign(value)
  }
  const onToogleNotify = useCallback(() => {
    setNotify((prevState) => !prevState)
  }, [])

  const obtainBalance = useCallback(async () => {
    REPOSITORY.wsEmpresa.dashboard
      .getCardsData(sEmpresa)
      .then((res) => {
        setAvailableBalance(res.data?.SaldoDisponibleRecarga)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [sEmpresa])

  const handleConfirm = () => {
    setShowConfirm(false)
    setConfirmed(true)
  }
  const handleShowConfirm = () => {
    setShowConfirm(true)
  }
  const totalAmount = useMemo(() => {
    const calculated = calculateAmount(cEmpleados)
    return Number(calculated)
  }, [cEmpleados])

  const doneRefill = useCallback(
    (code) => {
      if (code === 200) {
        navigate('/refills')
        handleClose()
      }
      handleClose()
    },
    [handleClose, navigate],
  )
  const handleChangeEmployeeData = useCallback(
    (_, employee) => {
      const validateNum = (nMonto) => {
        const s = String(nMonto ?? '').trim()

        if (!s) {
          return '$0'
        }

        const noDollar = s.replace(/\$/g, '') // o s.replaceAll('$','')
        if (isNaN(Number(noDollar))) {
          return '$0'
        }

        return s.replace(/-/g, '') // o s.replaceAll('-','')
      }

      const _employee = {
        ...employee,
        nMonto: validateNum(employee.nMonto),
      }

      //Estado independiente que guarda modificaciones para luego hacer la comparacion con la búsqueda y setear los montos actualizados
      setCEmpleados((prevEmpleados) => {
        // Busca índice del empleado en el array
        const index = prevEmpleados.findIndex(
          (emp) => emp.sEmpleado === _employee.sEmpleado,
        )

        let newEmpleados
        if (index !== -1) {
          // Si el empleado existe, actualiza el monto
          newEmpleados = prevEmpleados.map((emp, idx) => {
            if (idx === index) {
              return { ...emp, nMonto: _employee.nMonto } // Asumiendo que solo se cambia 'nMonto'
            }

            return emp
          })
        } else {
          // Si el empleado no existe, se agrega al array
          newEmpleados = [...prevEmpleados, _employee]
        }
        return newEmpleados
      })

      //Se corrige mutacion de estados que reseteaba montos a cero al cambiar de pagina
      setCEmpleados((prevState) => {
        const changeIndex = prevState.findIndex(
          (value) => value.sEmpleado === _employee.sEmpleado,
        )
        if (changeIndex !== -1) {
          const newState = [...prevState]
          newState[changeIndex] = { ...newState[changeIndex], ..._employee }
          return newState
        }
        return prevState
      })
    },
    [cEmpleados],
  )

  const onOkStatus = useCallback(
    (response) => {
      handleCLoseLoading()
      handleSetTitle(response.data.sMensaje, response.status)
      handleChangeBody(
        <Button variant="primary" onClick={() => doneRefill(response.status)}>
          {response.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
        </Button>,
      )
      handleOpen()
    },
    [
      doneRefill,
      handleCLoseLoading,
      handleChangeBody,
      handleOpen,
      handleSetTitle,
    ],
  )

  const onErrorStatus = useCallback(
    (error) => {
      handleCLoseLoading()
      handleSetTitle(error.response.data.error, error.response.status)
      handleChangeBody(
        <Button variant="primary" onClick={() => doneRefill(error)}>
          {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
        </Button>,
      )
      handleOpen()
    },
    [
      doneRefill,
      handleCLoseLoading,
      handleChangeBody,
      handleOpen,
      handleSetTitle,
    ],
  )

  const sendData = useCallback(
    async (newData) => {
      await REPOSITORY.wsEmpresa.refills
        .newRecharge(newData)
        .then((response) => {
          onOkStatus(response)
        })
        .catch((error) => {
          onErrorStatus(error)
        })
      handleCLoseLoading()
      setNotify(false)
      setCostCenterAssign(null)
    },
    [onErrorStatus, onOkStatus],
  )

  const onConfirm = useCallback(async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.company.validateCompanyInfo()

    const { user } = REPOSITORY.local.company.getUserData()
    const isProgrammed = data.sTipoRecarga === 'PROGRAMADA'
    await sendData({
      ...data,

      sTipoRecarga: isProgrammed ? 'CONFIRMARECARGA' : user.sTipoRecarga,
      sCentroCosto: costCenterAssign || null,
      bNotificarAsignacion: notitfy,
    })
  }, [data, handleOpenLoading, sendData, notitfy, costCenterAssign])

  useEffect(() => {
    if (confirmed) {
      onConfirm()
      setConfirmed(false)
    }
  }, [confirmed, onConfirm])

  useEffect(() => {
    obtainBalance()
  }, [obtainBalance])

  useEffect(() => {
    setCEmpleados([])
  }, [form])

  const getRecargaTypeSelect = () => {
    if (currentUser?.oEmpresa[0]?.sTipoRecarga == 'PREPAGO') {
      return rechargeTypes.filter((item) => item.id != 'PROGRAMADA')
    } else {
      return rechargeTypes
    }
  }

  return (
    <>
      <Formik
        initialValues={{
          sCentroCosto: '',
          sSucursal: '',
          sTipoRecarga: 'INMEDIATA',
          sEmpresa: sEmpresa,
          sFechaProgramacion: null,
          nMontoTotal: 0,
          cEmpleados: cEmpleados,
        }}
        validate={(values) => {
          const error = {}
          if (
            !values.sFechaProgramacion &&
            values.sTipoRecarga === 'PROGRAMADA'
          ) {
            error.sFechaProgramacion = 'Fecha obligatoria'
          }
          return error
        }}
        validateOnBlur
        onSubmit={async (values) => {
          onSelectCostCenter(values.sCentroCosto || null)

          if (cEmpleados.length > 0) {
            if (form?.component === 'massive') {
              const duplicates = []
              let duplicate = false

              for (const obj of cEmpleados) {
                const rutNorm = String(obj?.sRut ?? '')
                  .trim()
                  .replace(/\./g, '')
                  .replace(/-/g, '')

                if (duplicates.includes(rutNorm)) {
                  duplicate = true
                }
                duplicates.push(rutNorm)
              }

              if (duplicate) {
                setValidDuplicates({ valid: false, showModal: true })
                return
              }
            }

            const isProgrammed = values.sTipoRecarga === 'PROGRAMADA'
            const sendValues = {
              ...values,
              sFechaProgramacion: isProgrammed
                ? values.sFechaProgramacion
                : null,
            }
            if (form?.component === 'dni') {
              setData({
                ...formatDniData(
                  {
                    ...sendValues,
                    nMontoTotal: totalAmount,
                    cEmpleados: [
                      {
                        ...cEmpleados[0],
                        nMonto: Number(
                          numberFormat(cEmpleados[0].nMonto, 'number'),
                        ),
                      },
                    ],
                  },
                  sEmpresa,
                ),
              })
            } else if (
              form?.component === 'individual' ||
              form?.component === 'massive'
            ) {
              setData({
                ...formatDniData(
                  {
                    ...sendValues,
                    cEmpleados: cEmpleados,
                    nMontoTotal: totalAmount,
                  },
                  sEmpresa,
                ),
              })
            }
            handleShowConfirm()
          }

          handleShowConfirm()
        }}
      >
        {({ values, handleChange, handleSubmit, errors, touched, isValid }) => (
          <>
            <ConfirmModal
              isOpen={showConfirm}
              size="3xl"
              onContinue={handleConfirm}
              title="Autorización de recarga"
              onClose={() => setShowConfirm(false)}
              textButton="Realizar Recarga"
            >
              <RefillsConfirmation
                ammount={`${totalAmount}`}
                accounts={
                  cEmpleados.filter(
                    (item) => numberFormat(item.nMonto, 'number') > 0,
                  ).length
                }
                handleAssign={onSelectCostCenter}
                handleNotify={onToogleNotify}
                assign={costCenterAssign}
                notify={notitfy}
              />
            </ConfirmModal>
            <Flex direction="column">
              <Toast variant="dark" mb="16px">
                <RefillsIndicator
                  color="#FFFFFF"
                  icon={faDollarSign}
                  label={texts.available_balance}
                  subLabel={numberFormat(availableBalance, 'currency')}
                />
              </Toast>
              <Box>
                <UnderlineHeading
                  variant="h5"
                  text={texts.select_cost_center}
                />
              </Box>
              <Box mt="27px">
                <HStack spacing="47px" w="659px">
                  <SelectorField
                    value={values.sCentroCosto}
                    options={sCentroCosto || defaultOptions}
                    name="sCentroCosto"
                    title={texts.cost_center}
                    titleType={titleTypes.overline}
                    isClearable
                    placeholder="Seleccionar centro de costo"
                  />
                  <SelectorField
                    value={values.sSucursal}
                    options={branchOffices}
                    name="sSucursal"
                    title={texts.branch_office}
                    titleType={titleTypes.overline}
                    isClearable
                    placeholder="Seleccionar sucursal"
                  />
                </HStack>
              </Box>
              <Box mt="43px">
                <HStack
                  spacing="47px"
                  alignItems="flex-end"
                  justifyContent="space-between"
                  w="659px"
                >
                  <VStack w="306px" alignItems="flex-start" spacing="32px">
                    <UnderlineHeading variant="h5" text={texts.recharge_type} />
                    <SelectorField
                      value={values.sTipoRecarga}
                      name="sTipoRecarga"
                      options={getRecargaTypeSelect()}
                    />
                  </VStack>

                  {values.sTipoRecarga === 'PROGRAMADA' && (
                    <VStack alignItems="flex-start">
                      <Text variant="underline">{texts.recharge_date}</Text>
                      <Box w="306px" h="3.8vh">
                        <DatePickerField
                          id="sFechaProgramacion"
                          name="sFechaProgramacion"
                          minDate={addDays(new Date(), 1)}
                          value={values.sFechaProgramacion}
                          handleChange={handleChange}
                        />
                      </Box>
                      {errors.sFechaProgramacion &&
                        touched.sFechaProgramacion && (
                          <Text variant="error">
                            {errors.sFechaProgramacion}
                          </Text>
                        )}
                    </VStack>
                  )}
                </HStack>
              </Box>
              <Box mt="45px">
                <UnderlineHeading variant="h5" text={texts.recharge_form} />
              </Box>
              <RefillContext.Provider
                value={{
                  cEmpleados,
                  setCEmpleados,
                  cEmpleadosLocalFilter,
                  setCEmpleadosLocalFilter,
                  sucursal: values.sSucursal,
                  centroCosto: values.sCentroCosto,
                  totalAmount,
                  handleChangeEmployeeData,
                }}
              >
                <Box>
                  <RechargeForm
                    formType={formContexts.new_refill}
                    handleSelected={setForm}
                  />
                </Box>
              </RefillContext.Provider>
              {form?.component !== 'massive' && (
                <Box
                  onClick={
                    cEmpleados.length > 0 && totalAmount > 0
                      ? handleSubmit
                      : () => null
                  }
                  maxW="20vw"
                  h="6vh"
                  mt="48px"
                  mb="125px"
                >
                  <IconButton
                    variant={
                      cEmpleados.length > 0 && totalAmount > 0 && isValid
                        ? 'secondary'
                        : 'gray'
                    }
                    icon={faCheckCircle}
                    color={
                      cEmpleados.length > 0 && totalAmount > 0
                        ? 'FFFFFF'
                        : colors.gray[900]
                    }
                    text={texts.do_recharge}
                  />
                </Box>
              )}
            </Flex>
          </>
        )}
      </Formik>

      <Modal
        isOpen={validDuplicates.showModal}
        onClose={() => {
          setValidDuplicates({
            ...validDuplicates,
            showModal: false,
          })
        }}
        isCentered
      >
        <ModalOverlay onClick={() => {}} />
        <ModalContent maxWidth={400} paddingTop={7} paddingBottom={7}>
          <ModalBody>
            <VStack>
              <svg
                width="129"
                height="119"
                viewBox="0 0 129 119"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="92.5" cy="36" r="36" fill="#DDDDDD" />
                <path
                  d="M109.92 44.7968C110.711 44.7968 111.354 44.1534 111.354 43.3626V23.9522C111.354 19.9979 108.137 16.7809 104.183 16.7809H97.6808V13.4343C97.6808 12.6434 97.0374 12 96.2466 12H88.5971C87.8063 12 87.1629 12.6434 87.1629 13.4343V16.7809H80.6713C76.7171 16.7809 73.5 19.9979 73.5 23.9522V52.8287C73.5 56.783 76.7171 60 80.6713 60H104.183C108.137 60 111.354 56.783 111.354 52.8287C111.354 52.0378 110.711 51.3944 109.92 51.3944C109.129 51.3944 108.486 52.0378 108.486 52.8287C108.486 55.2012 106.555 57.1315 104.183 57.1315H80.6713C78.2988 57.1315 76.3685 55.2012 76.3685 52.8287V23.9522C76.3685 21.5796 78.2988 19.6494 80.6713 19.6494H87.1629V21.0837C87.1629 23.9835 89.5221 26.3426 92.4219 26.3426C95.3216 26.3426 97.6808 23.9835 97.6808 21.0837V19.6494H104.183C106.555 19.6494 108.486 21.5796 108.486 23.9522V43.3626C108.486 44.1534 109.129 44.7968 109.92 44.7968ZM92.4219 23.4741C91.1038 23.4741 90.0314 22.4018 90.0314 21.0837V14.8685H94.8123V21.0837C94.8123 22.4018 93.7399 23.4741 92.4219 23.4741Z"
                  fill="#565656"
                />
                <path
                  d="M83.9116 48.9048C83.9116 49.6957 84.555 50.3391 85.3459 50.3391H99.4973C100.288 50.3391 100.932 49.6957 100.932 48.9048C100.932 45.9864 99.4568 43.3028 96.9867 41.7265L96.5523 41.4492L96.8614 41.0368C97.5849 40.0713 97.9674 38.9236 97.9674 37.7177C97.9674 34.6597 95.4795 32.1719 92.4216 32.1719C89.3636 32.1719 86.8758 34.6597 86.8758 37.7177C86.8758 38.9239 87.2581 40.0716 87.9814 41.0368L88.2905 41.4492L87.856 41.7265C85.3861 43.3027 83.9116 45.9863 83.9116 48.9048ZM92.4216 40.3949C90.9453 40.3949 89.7443 39.1938 89.7443 37.7176C89.7443 36.2414 90.9453 35.0403 92.4216 35.0403C93.8978 35.0403 95.0989 36.2414 95.0989 37.7176C95.0989 39.1938 93.8978 40.3949 92.4216 40.3949ZM92.4216 43.2634C94.7414 43.2634 96.7982 44.6574 97.6617 46.8149L97.9241 47.4706H86.9187L87.1812 46.8149C88.0445 44.6574 90.1015 43.2634 92.4216 43.2634Z"
                  fill="#565656"
                />
                <path
                  d="M79.0761 119H13.924C3.95768 119 -2.5243 108.508 1.93261 99.5906L34.5087 34.4139C39.4493 24.5287 53.5506 24.5287 58.4913 34.4139L91.0671 99.5904C95.5245 108.508 89.0425 119 79.0761 119Z"
                  fill="#FFC107"
                />
                <path
                  d="M41.5 100.462C41.5 99.2004 42.0111 98.1291 43.033 97.2473C44.0551 96.3651 45.2973 95.9229 46.7575 95.9229C48.0434 95.9229 49.1549 96.3651 50.0922 97.2473C51.0297 98.1291 51.5 99.2004 51.5 100.462C51.5 101.672 51.03 102.731 50.0922 103.638C49.1549 104.546 48.0432 105 46.7575 105C45.2972 105 44.0551 104.546 43.033 103.638C42.0111 102.731 41.5 101.672 41.5 100.462ZM41.9918 56.0241C41.9918 54.7397 42.4257 53.7477 43.2943 53.0488C44.1625 52.3498 45.287 52 46.6677 52C48.0485 52 49.0629 52.3638 49.7095 53.091C50.3562 53.8181 50.6802 54.7956 50.6802 56.0241C50.6802 60.0498 50.6109 61.9199 50.4753 71.0301C50.3383 80.1407 50.2706 83.0114 50.2706 87.0356C50.2706 87.8754 49.88 88.5326 49.1001 89.007C48.3187 89.4815 47.5081 89.7191 46.6679 89.7191C44.2065 89.7191 42.9756 88.8254 42.9756 87.0357C42.9756 83.0116 42.8114 80.1408 42.4837 71.0303C42.1555 61.9197 41.9918 60.0497 41.9918 56.0241Z"
                  fill="white"
                />
              </svg>
              <Text align="center" paddingTop={5}>
                Se ha encontrado un colaborador duplicado en la planilla.
              </Text>
              <Text align="center" paddingBottom={3}>
                Corrígela para poder continuar con la recarga masiva.
              </Text>
              <HStack paddingStart={20} paddingEnd={20} width={'100%'}>
                <Button
                  onClick={() => {
                    setValidDuplicates({
                      ...validDuplicates,
                      showModal: false,
                    })
                  }}
                  variant="black"
                  borderRadius={10}
                >
                  Volver
                </Button>
              </HStack>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default NewRefill
